import { FC } from 'react';
import { VideoContent } from '../types';

interface VideoProps {
  content: VideoContent;
}

const Video: FC<VideoProps> = ({ content }) => {
  const { url, alt } = content;

  const allowFeatures = [
    'accelerometer',
    'autoplay',
    'clipboard-write',
    'encrypted-media',
    'gyroscope',
    'picture-in-picture',
    'web-share',
  ].join('; ');

  return (
    <div className="tips-modal__video-wrapper">
      <iframe
        loading="lazy"
        width="100%"
        className="tips-modal__video-iframe"
        height="100%"
        frameBorder="0"
        title={alt || 'video'}
        allow={allowFeatures}
        src={url}
        allowFullScreen
      />
    </div>
  );
};

export default Video;
